import moment from 'moment'

const TooltipCreator = (points, x) => {
  if (!points) {
    return
  }

  const tooltipPoints = points.map(point => `<Span class="highcharts-tooltip-label ">
                <P class="highcharts-tooltip-label-key">${point.series.name}</P>
                <P>${point.y}</P>
              </Span>`)

  let delta
  if (points.length > 1) {
    delta =
      points[1].y !== 0
        ? (points[0].y - points[1].y) /
          points[1].y *
          100
        : 0
  }

  const deltaString = (points.length > 1) ? `<Div class="highcharts-tooltip-label">
                    <P class="highcharts-tooltip-label-key">Change</P>
                    <Div class="reports-highchart-arrow-container">
                      <Span class=${delta >= 0 ? 'arrow-up' : 'arrow-down'}></Span>
                      <P class=${delta >= 0 ? 'delta-positive' : 'delta-negative'}>${delta.toFixed(2)}%</P>
                    </Div>
                  </Div>` : null
  
  return `
    <Div class="highcharts-tooltip-container reports-highcharts-tooltip-container">
      <Div class="reports-highcharts-tooltip-header">
        <Span>${moment.utc(x).format('MM/DD')}</Span>
        <br/>
      </Div>
      <Div class="reports-tooltip-label-container highcharts-tooltip-label-container">
        ${tooltipPoints.join('</br>')}
        </br>
        ${tooltipPoints.length >= 2 ? deltaString : ''}
      </Div>
    </Div>`
} 

export default TooltipCreator
